export const OK = 200;
export const BAD_GATEWAY = 502;
export const BAD_REQUEST = 400;
export const INTERNAL_SERVER_ERROR = 500;
export const NOT_FOUND = 404;
export const UPSTREAM_CODES_TO_PROPAGATE_IN_SIMORGH = [OK, NOT_FOUND];
